import React from "react";
import { Circle } from "react-konva";
import { useEPDStyle } from "../contexts/EPDStyle/useEPDStyle";
import { Point } from "@opstel/geo/Point";
import { SCALING_VECTOR } from "../core/layoutConstants";

type SwitchProps = {
  readonly topoPoint: Point;
  readonly trackLineWidth: number;
};

export function Switch({ topoPoint, trackLineWidth }: SwitchProps): React.JSX.Element {
  const { style } = useEPDStyle();
  const drawPoint = topoPoint.scale(SCALING_VECTOR);

  return (
    <Circle
      x={drawPoint.x}
      y={drawPoint.y}
      radius={4 * trackLineWidth}
      fill={style.infraItems.Switch.backgroundColor}
    />
  );
}
